/**
 * Full-screen Workout Calendar view.
 */
import { View, StyleSheet, Pressable } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';
import { SPACE } from '@/constants/tokens';
import { ArrowLeft } from 'lucide-react-native';
import WorkoutCalendar from '@/components/WorkoutCalendar';
import type { DaySummary } from '@/lib/workoutCalendar';

export default function WorkoutCalendarScreen() {
  const { theme } = useTheme();
  const c = theme.colors;
  const router = useRouter();

  const handleDayPress = (dateStr: string, summary: DaySummary | null) => {
    if (summary && summary.count > 0) {
      // Navigate to logs tab — the record screen with logs view would filter by date
      // For now, just go to the record tab (logs section)
      router.push('/(tabs)/record?view=logs' as any);
    }
  };

  return (
    <SafeAreaView style={[styles.safe, { backgroundColor: c.background }]} edges={['top']}>
      <Pressable onPress={() => router.back()} hitSlop={12} style={styles.backBtn}>
        <ArrowLeft size={24} color={c.text} />
      </Pressable>
      <View style={styles.content}>
        <WorkoutCalendar onDayPress={handleDayPress} />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safe: {
    flex: 1,
  },
  backBtn: {
    paddingHorizontal: SPACE['4'],
    paddingVertical: SPACE['2'],
  },
  content: {
    flex: 1,
    padding: SPACE['4'],
  },
});
